import React from 'react'
import { createRoot } from 'react-dom/client'
import AppRoutes from 'src/routes/AppRoutes'
import { Amplify } from 'aws-amplify'
import { CookieStorage } from 'aws-amplify/utils'

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID as string,
      userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID as string
    }
  },
  storage: new CookieStorage()
})

const container = document.getElementById('root') as HTMLElement
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!)
root.render(
  <React.StrictMode>
    <AppRoutes />
  </React.StrictMode>
)
